import "./assets/css/reset.css";
import "./assets/css/style.css";
import "./modules/calendarDOM";
import { displayWebsite } from "./modules/displayController";

displayWebsite();
